<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="700px"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span v-if="item.id">Cập nhật dữ liệu</span>
        <span v-else>Thêm mới</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div v-if="errors_exist" class="row">
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors"
                    :key="index"
                  >
                    <li>{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row>
            <v-col cols="12">
              <input 
                type="file" 
                @change="onFilePicked" 
                class="d-none" 
                ref="fileInput" 
                accept="image/*"
              />
              <v-hover v-slot="{ hover }">
                <v-img
                  v-if="logo_url"
                  :src="logo_url"
                  class="mx-auto elevation-1"
                  @click="onPickFile"
                  width="150"
                >
                  <div v-if="hover" class="avatar-icon-upload">
                    <v-icon large color="yellow">mdi-tray-arrow-up</v-icon>
                  </div>
                </v-img>
                <v-img
                  v-else
                  src="@/assets/NoImage.jpg"
                  class="mx-auto elevation-1"
                  @click="onPickFile"
                  width="150"
                >
                  <div v-if="hover" class="avatar-icon-upload">
                    <v-icon large color="yellow">mdi-tray-arrow-up</v-icon>
                  </div>
                </v-img>
              </v-hover>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.name"
                label="Tên hệ thống"
                class="require"
                autofocus
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.link"
                label="Trang web"
                class="require"
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="item.weblink"
                label="Liên kết (trang chủ)"
                color="pink"
                hide-details
              />
            </v-col>
          </v-row>
        </v-container>
        <v-overlay
          absolute
          :value="logoUploadStatus"
        >
          <v-btn color="success">
            <span class="mr-2">CHỜ TẢI ẢNH LÊN</span>
            <v-progress-circular
              indeterminate
              color="white"
            />
          </v-btn>
        </v-overlay>
      </v-card-text>
      <v-card-actions>
        <small><span class="pink--text">(*)</span> bắt buộc nhập</small>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="save(item)"
        >
          Lưu lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { mapActions, mapState } from 'vuex';
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object
      }
    },
    data () {
      return {
        loading: false,
        logoUploadStatus: false,
        dialog: false,
        errors_exist: false,
        errors: [],
        logo_url: null,
      }
    },
    computed: {
      ...mapState([
        'config'
      ])
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist=false;
        if (this.showDialog) {
          this.dialog = true;
          this.logo_url = null;
          if(this.item.logo) {
            this.logo_url = `${this.config.beUrl}/uploads/${this.item.logo}`;
          }
          if(this.item.weblink === '1'){
            this.item.weblink = true;
          } else {
            this.item.weblink = false;
          }
        }
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      onPickFile () {
        this.$refs.fileInput.click();
      },
      onFilePicked (event) {
        const app = this;
        app.logoUploadStatus = true;

        const file = event.target.files[0];
        app.logo_url = URL.createObjectURL(file);

        const config = {
          headers: { 'content-type': 'multipart/form-data' }
        };

        let formData = new FormData();
        formData.append('file', file);
        formData.append('folder', 'lienkets');

        axios.post('api/v1/images', formData, config)
          .then(function (response) {
            app.item.logo = response.data.filePath;
            app.openSnackbar({ 
              type: 'success',
              body: 'Tải lên hình ảnh thành công!'
            });
            app.logoUploadStatus=false;
          })
          .catch(function (error) {
            app.logo_url = null;
            app.openSnackbar({ type: 'error' });
            app.logoUploadStatus=false;
          });
      },
      save(item) {
        const app = this;
        let method = "post";
        let url = `api/v1/web-links`;
        let data = item;

        data.weblink = data.weblink ? data.weblink : 0;

        if (data.id) {
          method = "patch";
          url = `api/v1/web-links/${data.id}`;
        }

        app.loading=true;
        
        axios[method](url, data)
          .then((response) => {
            if (response.data && response.data.id) {
              app.$emit('confirmed', response.data);
            }
            app.loading=false;
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.loading=false;
            app.openSnackbar({ type: 'error' });
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      }
    }
  }
</script>

<style>
  .avatar-icon-upload{
    position: absolute;
    background: gray;
    width: 100%;
    height: 100%;
    opacity: 0.7;
    cursor: pointer;
  }
  .avatar-icon-upload .v-icon{
    font-size: 36px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>